import { services, url, environment } from '@octadesk-tech/services'

import { getParameterHeaders } from './headers'

const getClient = () => {
  const headers = getParameterHeaders()
  return services.main.getClient({ headers })
}

// OBSOLETE: Remove this function to new version without ticket
// Used to components "ProductService" and "UserProductService"
export const getMainUrl = () => url.getAPIURL('main')

const BASE_URLS = {
  [environment.DEFAULT_ENVIRONMENTS.dev]: 'devoctadesk.com',
  [environment.DEFAULT_ENVIRONMENTS.qa]: 'qaoctadesk.com',
  [environment.DEFAULT_ENVIRONMENTS.prd]: 'octadesk.com'
}

// OBSOLETE: Remove this function to new version without ticket
// Used to component "KbCard"
export const getBaseUrl = () => {
  if (!BASE_URLS[environment.getEnvironment()]) {
    return
  }

  const headers = getParameterHeaders()
  return `${headers.AppSubdomain}.${BASE_URLS[environment.getEnvironment()]}`
}

// OBSOLETE: Remove this function to new version without ticket
// Used to show field "subjectCategory"
export const searchSubjects = query =>
  getClient()
    .then(client =>
      client.get(
        `/adminData/getSubjects?invisibleToClient=true&showEnabledItems=true&search=${query}`
      )
    )
    .then(r => r.data)

// OBSOLETE: Remove this function to new version without ticket
// Used to show field "tags"
export const searchTags = query =>
  getClient()
    .then(client => client.get(`/adminData/getTagsAutoSuggest?search=${query}`))
    .then(r => r.data)

// OBSOLETE: Remove this function to new version without ticket
// Used to show field "productService"
export const searchProducts = query =>
  getClient()
    .then(client =>
      client.get(
        `/product/searchByValues?search=${query}&showEnabledItems=true`
      )
    )
    .then(r => r.data)

// OBSOLETE: Remove this function to new version without ticket
// Used to show field "priority"
export const getPriorities = () =>
  getClient()
    .then(client => client.get('/adminData/getAllPriorities'))
    .then(r => r.data)

// OBSOLETE: Remove this function to new version without ticket
// Used to show field "type"
export const getTicketTypes = () =>
  getClient()
    .then(client => client.get('/adminData/getAllTicketType'))
    .then(r => r.data)
